import styled from 'styled-components';

export const FooterContainer = styled.div`
  position: relative;
  z-index: 30;
  padding: 0 42px;
  width: 100%;
  height: 45px;
  line-height: 45px;
  background-color: ${({ theme: { colors } }) => colors['blue-5']};
  display: flex;
  justify-content: space-between;
  font-size: 13px;

  div {
    display: flex;
    flex-direction: row;
    color: ${({ theme: { colors } }) => colors['white']};
  }
`;

export const FooterLink = styled.span`
  margin-right: 15px;
  cursor: pointer;
`;
